export const GALLERY_ROUTE_URL = '/app/marketingsite/create';
export const EDITOR_ROUTE_URL = '/app/marketingsite/editor';

export const LIST_SOURCE_URL = '/app/marketingsite/list';

export const UNLAYER_ENV_URLS = {
    default: 'https://intg.keap.page',
    sandbox: 'https://intg.keap.page',
    integration: 'https://intg.keap.page',
    staging: 'https://stge.keap.page',
    stge: 'https://stge.keap.page',
    production: 'https://keap.page',
    prod: 'https://keap.page',
};


export const MARKETING_SITE_TEMPLATE_TYPES = {
    site: 'site', // site is copied from an existing site (from this app)
    unlayer: 'unlayer',
    blank: 'blank', // sites made from scratch
    global: 'global',
};

export const TEMPLATE_MEDIA = {
    Email: 'EMAIL',
    Web: 'WEB',
    LandingPage: 'LANDING_PAGE',
    Funnel: 'FUNNEL',
    TemplateFormType: 'WEB',
    TemplateFormSource: 'SMART',
};

export const TEMPLATE_SOURCE = {
    unlayer: 'UNLAYER',
};

export const TEMPLATE_STATUS = {
    Draft: 'DRAFT',
    Sent: 'COMPLETED',
    Saved: 'SAVED',
};

export const SITE_STATUS = {
    PUBLISHED: 'ACTIVE',
    PUBLISHED_CHANGES: 'ACTIVE_CHANGES',
    DRAFT: 'DRAFT',
    SAVED: 'SAVED',
};

export const KEAP_TOOLS = {
    keapForm: 'keap#form',
    keapCheckout: 'keap#checkout_form',
    unlayerForm: 'form',
};

export const UNLAYER_DOMAIN = 'unlayer.com';

export const KEAP_CUSTOM_LINK_TYPES = {
    marketingPage: 'marketingPage',
    marketingSite: 'marketingSite',
    keapCheckoutForm: 'checkoutForm',
    keapAppointmentType: 'appointmentType',
};

export const TEMPLATE_FORM = {
    TemplateFormType: 'WEB',
    TemplateFormSource: 'SMART',
};

export const STANDARD_BILLING_POSTAL_CODE_FIELD_ID = 'standard.billingAddress.postalCode';
export const STANDARD_BIRTHDAY_FIELD_ID = 'standard.birthDate';
export const STANDARD_WEBSITE_FIELD_ID = 'standard.website';
export const STANDARD_COMPANY_FIELD_ID = 'standard.company';
export const STANDARD_EMAIL1_FIELD_ID = 'standard.emailAddress1';
export const STANDARD_FAMILY_NAME_FIELD_ID = 'standard.familyName';
export const STANDARD_GIVEN_NAME_FIELD_ID = 'standard.givenName';
export const STANDARD_NOTE_FIELD_ID = 'standard.note';
export const STANDARD_PHONE1_FIELD_ID = 'standard.phoneNumber1.value';
export const STANDARD_PHONE1_TYPE_FIELD_ID = 'standard.phoneNumber1.type';

export const FORM_STATUSES = {
    PUBLISHED: 'Published',
    NOT_PUBLISHED: 'NotPublished',
};
export const FORM_TYPE_LANDING_PAGE = 'LandingPage';
export const FORM_AUDIENCE_PUBLIC = 'Public';
export const KEAP_TOOLS_FORM_COUNTER_KEY = `u_content_custom_${KEAP_TOOLS.keapForm}`;

export const DEFAULT_LANDINGPAGE_FORM = {
    formType: FORM_TYPE_LANDING_PAGE,
    description: '',
    status: 'NotPublished',
    audience: FORM_AUDIENCE_PUBLIC,
};

export const MARKETING_SITE_UNLAYER_VERSION = '1.248.0';
